import { getCorrelationDelta } from 'nmr-correlation';
export function createMapPossibleAssignment(expandMap, props) {
    const { restrictionByCS, predictions, targets } = props;
    const { tolerance: toleranceCS, chemicalShiftRestriction } = restrictionByCS;
    const atomTypes = Object.keys(predictions);
    for (const atomType of atomTypes) {
        const errorAbs = toleranceCS[atomType];
        const predictionByAtomType = predictions[atomType];
        const targetByAtomType = targets[atomType];
        if (!expandMap[atomType])
            expandMap[atomType] = {};
        for (const diaID in predictionByAtomType) {
            const prediction = predictionByAtomType[diaID];
            expandMap[atomType][diaID] = [];
            if (targetByAtomType) {
                for (const targetID in targetByAtomType) {
                    const target = targetByAtomType[targetID];
                    const { nbAtoms, protonsCount: protonsCountFromPrediction } = prediction;
                    const { integration, protonsCount } = target;
                    const couldBeAssigned = !integration
                        ? true
                        : atomType === 'H'
                            ? nbAtoms - integration < 1
                            : protonsCount.length > 0
                                ? protonsCount.some((count) => protonsCountFromPrediction === count)
                                : true;
                    if (couldBeAssigned) {
                        if (!chemicalShiftRestriction ||
                            typeof prediction.delta === 'undefined') {
                            // Chemical shift is not a restriction
                            expandMap[atomType][diaID].push(targetID);
                        }
                        else {
                            const targetDelta = getCorrelationDelta(target);
                            if (targetDelta === undefined) {
                                throw new Error(`Correlation has not delta`);
                            }
                            const distAfterLimit = Math.abs(prediction.delta - targetDelta - errorAbs);
                            if (distAfterLimit < 4 * errorAbs) {
                                expandMap[atomType][diaID].push(targetID);
                            }
                        }
                    }
                }
            }
            expandMap[atomType][diaID].push('*');
        }
    }
    return expandMap;
}
//# sourceMappingURL=createMapPossibleAssignment.js.map